import { render, staticRenderFns } from "./PatentContactInfo.vue?vue&type=template&id=2bc06d37"
import script from "./PatentContactInfo.vue?vue&type=script&lang=js"
export * from "./PatentContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports